import ReactGA from "react-ga4";
import { getAnalyticsConsentState } from "./consent";

const GA_MEASUREMENT_ID = "G-WXZQ92TM53";
let gaStarted = false;

const pageTitles = [
  { pattern: /^\/$/, title: "Strona główna" },
  { pattern: /^\/rezerwacje\/?$/, title: "Rezerwacje" },
  { pattern: /^\/galeria-bydgoszcz\/?$/, title: "Galeria Bydgoszcz" },
  { pattern: /^\/polityka-prywatnosci\/?$/, title: "Polityka prywatności" },
  { pattern: /^\/regulaminy\/?$/, title: "Regulaminy" },
  { pattern: /^\/historia-cygar\/?$/, title: "Historia cygar" },
  { pattern: /^\/rodzaje-cygar\/?$/, title: "Rodzaje cygar" },
  { pattern: /^\/jak-palic-cygaro\/?$/, title: "Jak palić cygaro" },
  { pattern: /^\/jak-przechowywac-cygara\/?$/, title: "Jak przechowywać cygara" },
  {
    pattern: /^\/jakie-cygaro-na-poczatek\/?$/,
    title: "Jakie cygaro na początek",
  },
  {
    pattern: /^\/grill-przy-stole-bydgoszcz\/?$/,
    title: "Grill przy stole Bydgoszcz",
  },
  {
    pattern: /^\/grill-przy-stole-gdansk\/?$/,
    title: "Grill przy stole Gdańsk",
  },
  {
    pattern: /^\/palarnia-cygar-bydgoszcz\/?$/,
    title: "Palarnia cygar Bydgoszcz",
  },
  { pattern: /^\/torun\/?$/, title: "Toruń" },
  { pattern: /^\/bydgoszcz\/?$/, title: "Bydgoszcz" },
  { pattern: /^\/gdansk\/?$/, title: "Gdańsk" },
];

const fallbackTitle = (pathname) =>
  pathname
    .replace(/^\/+|\/+$/g, "")
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const getPolishPageTitle = (pathname) => {
  const matchedPage = pageTitles.find(({ pattern }) => pattern.test(pathname));
  return matchedPage ? matchedPage.title : fallbackTitle(pathname) || "Strona";
};

const enableAnalyticsConsent = () => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
};

export const initGA = () => {
  if (gaStarted) return;
  const consent = getAnalyticsConsentState();
  if (consent === "all") {
    enableAnalyticsConsent();
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gtagOptions: {
        send_page_view: false,
      },
    });
    gaStarted = true;
  }
};

export const sendPageview = (path) => {
  const consent = getAnalyticsConsentState();
  if (consent === "all") {
    if (!gaStarted) {
      enableAnalyticsConsent();
      ReactGA.initialize(GA_MEASUREMENT_ID, {
        gtagOptions: {
          send_page_view: false,
        },
      });
      gaStarted = true;
    }

    const [pathname] = path.split("?");
    const title = getPolishPageTitle(pathname);

    if (typeof document !== "undefined") {
      document.title = `${title} | WhiteBull`;
    }

    ReactGA.send({ hitType: "pageview", page: path, title });
  }
};

export const trackEvent = ({ category, action, label, value, nonInteraction }) => {
  const consent = getAnalyticsConsentState();
  if (consent !== "all") return;
  if (!gaStarted) {
    enableAnalyticsConsent();
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gtagOptions: {
        send_page_view: false,
      },
    });
    gaStarted = true;
  }

  ReactGA.event({
    category,
    action,
    label,
    value,
    nonInteraction,
    transport: "beacon",
  });
};

export const trackReservationClick = (label) => {
  trackEvent({
    category: "Rezerwacje",
    action: "Kliknięcie przycisku rezerwacji",
    label,
  });
};

export const trackUTMs = () => {
  const url = new URL(window.location.href);
  const source = url.searchParams.get("utm_source");
  const medium = url.searchParams.get("utm_medium");
  const campaign = url.searchParams.get("utm_campaign");
  const content = url.searchParams.get("utm_content");
  const term = url.searchParams.get("utm_term");

  if (source) sessionStorage.setItem("utm_source", source);
  if (medium) sessionStorage.setItem("utm_medium", medium);
  if (campaign) sessionStorage.setItem("utm_campaign", campaign);
  if (content) sessionStorage.setItem("utm_content", content);
  if (term) sessionStorage.setItem("utm_term", term);
};
